import { useGetJobsQuery } from '@diditusa/shared/api/jobsApi';
import UserJobs from '../../components/Job/UserJobs';
import UserJobsPrevious from '../../components/Job/UserJobsPrevious';
import React, { useEffect, useState } from 'react';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import { useNavigate } from 'react-router-dom';
import './PreviousOrders.css';

const PreviousOrders: React.FC = () => {
  const { data: jobs, ...loadJobsState } = useGetJobsQuery();
  const navigate = useNavigate();
  const [upcomingJobs, setUpcomingJobs] = useState<any[]>([]);
  const [pastJobs, setPastJobs] = useState<any[]>([]);

  useEffect(() => {
    if (!loadJobsState.isLoading && jobs) {
      const now = new Date();
      const future: any[] = [];
      const past: any[] = [];

      jobs.forEach((job) => {
        const jobStart = job.startTime.toJSDate();
        if (jobStart.getTime() > now.getTime()) {
          future.push(job);
        } else {
          past.push(job);
        }
      });

      // Optional: Sort both arrays
      future.sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());
      past.sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime());

      setUpcomingJobs(future);
      setPastJobs(past);
    }
  }, [loadJobsState.isLoading, jobs]);

  const getOnAgentNameClick = () => {
    return (jobId: number) => navigate(`/jobs/${jobId}`);
  };

  const renderJobsSection = () => {
    if (loadJobsState.isLoading) return <LoadingIndicator isVisible />;
    if (loadJobsState.isError) return <p>Error loading jobs</p>;

    return (
      <div className='previous-orders-wrapper'>
        <div className='upcoming-orders-wrapper'>
          {/* <h2 style={{ fontFamily: "'Nunito' , sans-serif" }}>Your Upcoming Experiences</h2> */}
          {upcomingJobs.length === 0 ? (
            <div className='upcoming-card'>
              <div className='upcoming-image'></div>
              <div className='upcoming-info'>
                <img
                  src='/NoExperiences.png'
                  alt='No Protection'
                  style={{
                    width: '600px',
                    height: '150px',
                    borderRadius: '20px',
                  }}
                  className='desktop-image'
                />
                <img
                  src='/NoExperiencesMobile.png'
                  alt='No Protection'
                  style={{
                    width: '600px',
                    height: '250px',
                    borderRadius: '20px',
                  }}
                  className='mobile-image'
                />
              </div>
            </div>
          ) : (
            <UserJobs sortedJobs={upcomingJobs} onAgentNameClick={getOnAgentNameClick()} />
          )}
        </div>

        <h2
          style={{
            marginTop: '0rem',
            marginBottom: '0rem',
            fontFamily: "'Nunito' , sans-serif",
            fontSize: '3rem',
          }}
        >
          Past Experiences
        </h2>
        {pastJobs.length === 0 ? (
          <p>No past experiences recorded.</p>
        ) : (
          <UserJobsPrevious sortedJobs={pastJobs} />
        )}
      </div>
    );
  };

  return <div>{renderJobsSection()}</div>;
};

export default PreviousOrders;
